import type { FireIconProps } from './types';

export default function HighRise({ size = 24, color = 'currentColor', strokeWidth = 2, className, ...props }: FireIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"
      className={className} {...props}>
      {/* Building outline */}
      <rect x="4" y="2" width="16" height="20" rx="1" />
      {/* Windows row 1 */}
      <rect x="7" y="4" width="3" height="2" rx="0.3" />
      <rect x="14" y="4" width="3" height="2" rx="0.3" />
      {/* Windows row 2 */}
      <rect x="7" y="8" width="3" height="2" rx="0.3" />
      <rect x="14" y="8" width="3" height="2" rx="0.3" />
      {/* Windows row 3 */}
      <rect x="7" y="12" width="3" height="2" rx="0.3" />
      <rect x="14" y="12" width="3" height="2" rx="0.3" />
      {/* Door */}
      <rect x="10" y="17" width="4" height="5" rx="0.5" />
    </svg>
  );
}
